module.exports = __webpack_public_path__ + "assets/img/35_1113_big.ab165642.jpg";